import "rxjs"
import {ajax} from "rxjs/observable/dom/ajax"
import config from "../../config"
import errorHandlerBuilder from "../errorHandlerBuilder"
import {
  ACTION_COGOLAND_RESCHEDULE_SESSION_LOADING,
  ACTION_COGOLAND_RESCHEDULE_SESSION_LOADED,
  ACTION_COGOLAND_RESCHEDULE_SESSION_ERROR,
  PATH_COGOLAND_RESCHEDULE_SESSION, EVENT_COGOLAND_SESSION_RESCEDULED
} from "../../constants"

import {format} from '../../util/DateUtil'

const api_server_host = config.api_server_host

const errorHandler = errorHandlerBuilder(ACTION_COGOLAND_RESCHEDULE_SESSION_ERROR)

const epic = (action$, store)=>
  action$.ofType(ACTION_COGOLAND_RESCHEDULE_SESSION_LOADING)
    .mergeMap(action => {

      const tokenData = store.getState().user
      const token = tokenData.access_token
      const type = tokenData.token_type

      const {dateTimeUnlock, id} = action.payload
      const body = {
        id,
        dateTimeUnlock: format(dateTimeUnlock),
      }

      return ajax({
        method: 'POST',
        url: `${api_server_host}${PATH_COGOLAND_RESCHEDULE_SESSION}`,
        headers: {
          Authorization: `${type} ${token}`,
          'Content-Type': 'application/json'
        },
        body,
        responseType: 'json'
      }).map(data=> {

        return {
          type: ACTION_COGOLAND_RESCHEDULE_SESSION_LOADED,
          payload: data.response
        }
      }).rxEmit(EVENT_COGOLAND_SESSION_RESCEDULED).catch(errorHandler)

    })

export default epic



// WEBPACK FOOTER //
// ./src/epics/cogoland/RescheduleSessionEpic.js